<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.51 6.14063C56.51 7.93555 55.0503 9.39063 53.2498 9.39063C51.4492 9.39063 49.9896 7.93555 49.9896 6.14063C49.9896 4.3457 51.4492 2.89062 53.2498 2.89062C55.0503 2.89062 56.51 4.3457 56.51 6.14063ZM55.4233 26.3628C55.4233 38.7279 45.3679 48.7517 32.9641 48.7517C20.5602 48.7517 10.5049 38.7279 10.5049 26.3628C10.5049 13.9978 20.5602 3.97396 32.9641 3.97396C45.3679 3.97396 55.4233 13.9978 55.4233 26.3628ZM59.9513 12.6406C60.8516 12.6406 61.5814 11.9131 61.5814 11.0156C61.5814 10.1182 60.8516 9.39063 59.9513 9.39063C59.051 9.39063 58.3212 10.1182 58.3212 11.0156C58.3212 11.9131 59.051 12.6406 59.9513 12.6406Z"
      fill="url(#paint0_radial_9931_22879)"
    />
    <path
      d="M26.2558 8.25851C26.463 7.48794 27.2575 7.03066 28.0305 7.23713L48.0162 12.5755C48.4333 12.6869 48.7787 12.9779 48.9585 13.3692L50.5869 16.9129C50.7273 17.2186 50.7564 17.5635 50.6691 17.8883L44.042 42.5435C43.8349 43.3141 43.0404 43.7714 42.2674 43.5649L19.8737 37.5833C19.1007 37.3768 18.642 36.5848 18.8491 35.8142L26.2558 8.25851Z"
      fill="url(#paint1_radial_9931_22879)"
    />
    <g filter="url(#filter0_d_9931_22879)">
      <path
        d="M19.9233 15.1671C19.9233 14.3694 20.5721 13.7227 21.3723 13.7227H44.556C45.3562 13.7227 46.005 14.3694 46.005 15.1671V40.0838C46.005 40.8815 45.3562 41.5282 44.556 41.5282H21.3723C20.5721 41.5282 19.9233 40.8815 19.9233 40.0838V15.1671Z"
        fill="#D9D9D9"
      />
      <path
        d="M19.9233 15.1671C19.9233 14.3694 20.5721 13.7227 21.3723 13.7227H44.556C45.3562 13.7227 46.005 14.3694 46.005 15.1671V40.0838C46.005 40.8815 45.3562 41.5282 44.556 41.5282H21.3723C20.5721 41.5282 19.9233 40.8815 19.9233 40.0838V15.1671Z"
        fill="url(#paint2_radial_9931_22879)"
      />
    </g>
    <path
      d="M19.9233 11.5558C19.9233 10.758 20.5721 10.1113 21.3723 10.1113H42.0631C42.4948 10.1113 42.9041 10.3033 43.1794 10.6348L45.6723 13.6377C45.8873 13.8967 46.005 14.2224 46.005 14.5586V40.0835C46.005 40.8813 45.3562 41.528 44.556 41.528H21.3723C20.5721 41.528 19.9233 40.8813 19.9233 40.0835V11.5558Z"
      fill="url(#paint3_radial_9931_22879)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M38.8958 8.17702C38.602 8.24066 38.2949 8.43538 38.0526 8.8539L35.1831 13.8083C35.1015 13.9492 35.1057 14.0945 35.1959 14.2603C35.2926 14.4382 35.4831 14.6198 35.7271 14.756C35.9708 14.892 36.2304 14.9616 36.4394 14.9546C36.6395 14.948 36.7613 14.8766 36.8308 14.7566L38.6515 11.613C38.714 11.505 38.7101 11.4266 38.6927 11.3728C38.6727 11.3112 38.6234 11.2494 38.5501 11.2072C38.4768 11.165 38.3985 11.1533 38.3349 11.1669C38.2795 11.1787 38.2094 11.2146 38.1469 11.3225L36.7506 13.7334C36.6505 13.9062 36.429 13.9653 36.2557 13.8656C36.0825 13.7659 36.0231 13.545 36.1231 13.3723L37.5194 10.9614C37.6783 10.6872 37.9157 10.5178 38.1832 10.4607C38.4426 10.4054 38.7026 10.461 38.9123 10.5817C39.122 10.7024 39.3005 10.8991 39.382 11.1507C39.4662 11.4102 39.4378 11.6998 39.279 11.9741L37.4583 15.1178C37.232 15.5084 36.8432 15.6639 36.4635 15.6765C36.0925 15.6888 35.7028 15.5701 35.3733 15.3862C35.0442 15.2026 34.7376 14.9331 34.5589 14.6045C34.3737 14.2638 34.324 13.8472 34.5557 13.4472L37.4251 8.49279C37.759 7.9164 38.2287 7.58244 38.742 7.47126C39.2475 7.36177 39.76 7.47591 40.1774 7.72759C41.0136 8.23182 41.5342 9.34242 40.876 10.4789L40.6949 10.7916L40.0674 10.4305L40.2485 10.1178C40.6762 9.37935 40.3613 8.68255 39.8024 8.34556C39.5223 8.17662 39.1974 8.1117 38.8958 8.17702Z"
      fill="url(#paint4_radial_9931_22879)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.2395 16.6142C32.6397 16.6142 32.964 16.2908 32.964 15.8919V15.5308C32.964 15.1319 32.6397 14.8086 32.2395 14.8086L22.8212 14.8086C22.421 14.8086 22.0967 15.1319 22.0967 15.5308V15.8919C22.0967 16.2908 22.421 16.6142 22.8212 16.6142L32.2395 16.6142ZM27.5304 18.7808C27.5304 19.1797 27.206 19.503 26.8059 19.503L22.8212 19.503C22.421 19.503 22.0967 19.1797 22.0967 18.7808V18.4197C22.0967 18.0208 22.421 17.6975 22.8212 17.6975L26.8059 17.6975C27.206 17.6975 27.5304 18.0208 27.5304 18.4197V18.7808ZM44.1936 22.753C44.1936 23.1519 43.8693 23.4753 43.4691 23.4753L22.8212 23.4753C22.421 23.4753 22.0967 23.1519 22.0967 22.753V22.3919C22.0967 21.9931 22.421 21.6697 22.8212 21.6697L43.4691 21.6697C43.8693 21.6697 44.1936 21.9931 44.1936 22.3919V22.753ZM44.1936 39.003C44.1936 39.4019 43.8693 39.7253 43.4691 39.7253L22.8212 39.7253C22.421 39.7253 22.0967 39.4019 22.0967 39.003L22.0967 28.8919C22.0967 28.4931 22.421 28.1697 22.8212 28.1697L43.4691 28.1697C43.8693 28.1697 44.1936 28.4931 44.1936 28.8919V39.003ZM43.4691 26.7253C43.8693 26.7253 44.1936 26.4019 44.1936 26.003V25.6419C44.1936 25.2431 43.8693 24.9197 43.4691 24.9197L22.8212 24.9197C22.421 24.9197 22.0967 25.2431 22.0967 25.6419V26.003C22.0967 26.4019 22.421 26.7253 22.8212 26.7253L43.4691 26.7253Z"
      fill="url(#paint5_radial_9931_22879)"
    />
    <defs>
      <filter
        id="filter0_d_9931_22879"
        x="13.6322"
        y="11.0265"
        width="38.6638"
        height="40.387"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.59494" />
        <feGaussianBlur stdDeviation="3.14557" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.705469 0 0 0 0 0.732812 0 0 0 0 0.7875 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9931_22879"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_9931_22879"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_radial_9931_22879"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(52.8875 -9.2066) rotate(115.508) scale(69.8193 69.9573)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_9931_22879"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(44.5558 26.1827) rotate(-130.009) scale(23.1014 25.3113)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_9931_22879"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(52.3443 48.0801) rotate(-133.074) scale(47.4722 52.8316)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_9931_22879"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(52.3443 48.9308) rotate(-129.607) scale(50.855 55.7222)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_9931_22879"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(40.5977 6.76698) rotate(127.661) scale(32.3485 11.6057)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_9931_22879"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.2701 26.003) rotate(27.0623) scale(32.5426 35.6941)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
    </defs>
  </svg>
</template>
